export const BANNER_ADD_REQUEST = "BANNER_ADD_REQUEST";
export const BANNER_ADD_SUCCESS = "BANNER_ADD_SUCCESS";
export const BANNER_ADD_FAIL = "BANNER_ADD_FAIL";

export const BANNER_DETAIL_REQUEST = "BANNER_DETAIL_REQUEST";
export const BANNER_DETAIL_SUCCESS = "BANNER_DETAIL_SUCCESS";
export const BANNER_DETAIL_FAIL = "BANNER_DETAIL_FAIL";

export const BANNER_UPDATE_REQUEST = "BANNER_UPDATE_REQUEST";
export const BANNER_UPDATE_SUCCESS = "BANNER_UPDATE_SUCCESS";
export const BANNER_UPDATE_FAIL = "BANNER_UPDATE_FAIL";

export const BANNER_DELETE_REQUEST = "BANNER_DELETE_REQUEST";
export const BANNER_DELETE_SUCCESS = "BANNER_DELETE_SUCCESS";
export const BANNER_DELETE_FAIL = "BANNER_DELETE_FAIL";

export const BANNER_LIST_REQUEST = "BANNER_LIST_REQUEST";
export const BANNER_LIST_SUCCESS = "BANNER_LIST_SUCCESS";
export const BANNER_LIST_FAIL = "BANNER_LIST_FAIL";
